import { marked } from 'marked';
import DOMPurify from 'dompurify';

// 변환 후 내용이 남지 않는 문단인지 판별한다.
// 빈 줄과 구분선(---)이 여기 해당하며, 걸러내지 않으면 문단 단위로 카드를 그리는
// 화면(.analysis-paragraph 등)에 껍데기만 남는다.
export const isBlankBlock = (block) => !block.trim() || /^-{3,}$/.test(block.trim());

// GitHub Flavored Markdown 사용 — 표·코드블록·인용문·중첩 목록까지 처리한다.
// breaks: 단일 줄바꿈도 <br> 로 (GitHub 코멘트와 같은 동작). AI 응답이 한 줄에
// 한 항목씩 쓰는 경우가 많아 이 옵션이 없으면 줄이 모두 붙어 버린다.
marked.setOptions({ gfm: true, breaks: true });

// 마크다운 → HTML 변환 (dangerouslySetInnerHTML 용).
// AI 응답을 그대로 주입하므로 DOMPurify 로 살균한 뒤 반환한다.
// 표는 좁은 화면에서 레이아웃을 밀어내므로 자체 가로 스크롤 영역으로 감싼다.
export const md = (text) =>
  DOMPurify.sanitize(marked.parse(text ?? ''), { ADD_ATTR: ['target', 'rel'] })
    .replace(/<table>/g, '<div class="table-scroll"><table>')
    .replace(/<\/table>/g, '</table></div>');
